<script lang="ts">
  import ModalPartial from './ModalPartial.svelte';

  export let modalPartialConfig: ModalPartialConfig;
  export let unsupportedBrowserModalBody: string;

  const unsupportedBrowsers: { name: string; url: string }[] = [
    { name: 'Google Chrome', url: 'https://chrome.com' },
    { name: 'Mozilla Firefox', url: 'https://firefox.com' },
    { name: 'Microsoft Edge', url: 'https://microsoftedge.com' },
  ];
  const closeModal = () => {
    modalPartialConfig.active = false;
  };
</script>

<ModalPartial {modalPartialConfig}>
  <p>{unsupportedBrowserModalBody}</p>
  <hr />
  <ul>
    {#each unsupportedBrowsers as unsupportedBrowser}
      <li>
        <a href={unsupportedBrowser['url']} target="_blank" rel="noreferrer">
          {unsupportedBrowser['name']}
          <svg aria-hidden width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.56997 0.5C6.12671 0.5 5.76737 0.859333 5.76737 1.30259C5.76737 1.74585
                6.12671 2.10518 6.56997 2.10518H9.24097L4.02732 7.31883C3.71389 7.63226
                3.71389 8.14044 4.02732 8.45387C4.34075 8.7673 4.84893 8.7673 5.16236
                8.45387L10.376 3.24022V5.91122C10.376 6.35448 10.7353 6.71381 11.1786
                6.71381C11.6219 6.71381 11.9812 6.35448 11.9812 5.91122V1.30259C11.9812
                0.859333 11.6219 0.5 11.1786 0.5H6.56997Z"
            />
            <path
              d="M1.60518 4.10571C1.60518 4.01481 1.67888 3.94111 1.76978
                3.94111H4.73307C5.17633 3.94111 5.53566 3.58178 5.53566 3.13852C5.53566
                2.69526 5.17633 2.33593 4.73307 2.33593H1.76978C0.79236 2.33593 0 3.12829 0
                4.10571V10.7302C0 11.7076 0.792359 12.5 1.76978 12.5H8.39429C9.37171 12.5
                10.1641 11.7076 10.1641 10.7302V7.8195C10.1641 7.37624 9.80474 7.01691
                9.36148 7.01691C8.91822 7.01691 8.55889 7.37624 8.55889
                7.8195V10.7302C8.55889 10.8211 8.48519 10.8948 8.39429
                10.8948H1.76978C1.67888 10.8948 1.60518 10.8211 1.60518 10.7302V4.10571Z"
            />
          </svg>
        </a>
      </li>
    {/each}
  </ul>
  <hr />
  <button on:click={closeModal}>{modalPartialConfig.proceedText}</button>
</ModalPartial>

<style lang="scss">
  // This modal renders on browsers that don't support ES6 so CSS vars and complex styling can't be used here
  button {
    border: none;
    background: none;
    color: #737373;
    cursor: pointer;
    font-size: 12px;
    padding: 0;
    margin: -8px -16px;
    padding: 8px 16px;
  }

  button::after {
    content: ' >';
    display: inline;
  }

  hr {
    padding: 0;
    margin: 12px 0;
    border-top: 1px solid rgba(128, 128, 128, 0.35);
  }

  ul {
    margin: 16px 0 0;
  }

  ul li {
    padding-left: 0;
  }

  ul li a {
    font-family: 'Square Sans Display VF, Square Sans Display, Helvetica, Arial, Hiragino Kaku Gothic Pro, ヒラギノ角ゴ Pro W3, メイリオ, Meiryo, ＭＳ Ｐゴシック, sans-serif;';
    font-size: 16px;
    line-height: 28px;
    margin: -8px -16px;
    padding: 8px 16px;
  }

  path,
  svg {
    fill: #006aff;
  }

  p {
    font-family: 'Square Sans Display VF, Square Sans Display, Helvetica, Arial, Hiragino Kaku Gothic Pro, ヒラギノ角ゴ Pro W3, メイリオ, Meiryo, ＭＳ Ｐゴシック, sans-serif;';
    margin: 12px 0 0;
    padding: 0;
    font-size: 16px;
    line-height: 28px;
    font-weight: 400;
  }
</style>
